const mutations = {
  setDialogsCloseOnEscape(state, n) {
    state.dialogs.closeOnEscape = n;
  },
  setDialogsDismissableMask(state, n) {
    state.dialogs.dismissableMask = n;
  },
  setLayout(state, n) {
    state.layout = n;
  },
  setShowSidebar(state, n) {
    state.showSidebar = n;
  },
  setSqlCode(state, n) {
    state.sqlCode = n;
  },
  addGraph(state, n) {
    state.graphs.push(n);
  },
  removeGraph(state, n) {
    state.graphs.splice(n, 1);
  },
  setTriggerImpersonationUser(state, n) {
    state.triggerImpersonationUser = n;
  },
  setLoadingUserGroups(state, n) {
    state.loadingUserGroups = n;
  },
  setClosingSession(state, n) {
    state.closingSession = n;
  },
};

export default mutations;
